<template>
  <div>
    <h4 class="title ml-3">
      {{ $t('box.efficiency') + $t('dashboards.for') + tabPeriodText }}
      <i id="efficiencyInfo" class="mdi mdi-24px mdi-info mdi-information-outline"></i>
    </h4>
    <b-tooltip
      custom-class="info-tooltip"
      target="efficiencyInfo"
      variant="danger"
      :title="$t('boxInfo.tooltip.efficiency')"
    ></b-tooltip>
    <div v-if="loading" class="dot-opacity-loader" style="z-index: 5">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div
      v-else-if="efficiencyValues && efficiencyValues.length"
      id="efficiencyChartContainer"
      style="height: 300px"
    ></div>
    <h4 v-else class="text-center p-3">{{ $t('dashboards.noData') }}</h4>
  </div>
</template>

<script>
import workCenterEfficiency from '@/api/boxinfo/workCenterEfficiency.gql';
import moment from 'moment';
import CanvasJS from '@/plugins/canvasjs.min';
const canvas = CanvasJS.Chart ? CanvasJS : window.CanvasJS;

export default {
  name: 'BoxEfficiencyCanvasPlot',
  props: {
    workCenterId: String,
    period: Object,
    targetEfficiency: Number,
    tabPeriodText: String,
  },
  apollo: {
    efficiencyValues: {
      query: workCenterEfficiency,
      variables() {
        return {
          workCenterId: this.workCenterId,
          period: this.period,
        };
      },
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        return (queryData || {}).overallEfficiency || [];
      },
      skip() {
        return !this.workCenterId || !this.period;
      },

      pollInterval: 600000,
      fetchPolicy: 'cache-and-network',
    },
  },
  data: () => {
    return {
      efficiencyValues: [],
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    dataSeries() {
      return this.efficiencyValues.map((i) => {
        return {
          type: 'area',
          color: this.getPointColor(i.oee),
          markerSize: 0,
          highlightEnabled: false,
          dataPoints: [
            {
              x: moment(i.dateFrom).add(1, 'h').valueOf(),
              y: i.oee < 3 ? 3 : i.oee,
              //color: this.getPointColor(i.oee)
            },
            {
              x: moment(i.dateFrom).valueOf(),
              y: i.oee < 3 ? 3 : i.oee,
              //color: this.getPointColor(i.oee)
            },
          ],
        };
      });
    },
    chartOptionsCj() {
      const vm = this;
      return {
        theme: 'dark2',
        zoomEnabled: true,
        zoomType: 'x',
        backgroundColor: 'rgb(25, 28, 36)',
        dataPointWidth: 100,
        axisX: {
          minimum: vm.minDate,
          maximum: vm.maxDate,
          lineThickness: 1,
          gridThickness: 0,
          lineColor: 'grey',
          labelFontColor: 'grey',
          tickColor: 'grey',
          labelMaxWidth: 40,
          interval: 14400000,
          labelFontSize: 10,
          labelFormatter: function (e) {
            const width = e.chart.width;
            const timestamp = e.axis.maximum - e.axis.minimum;
            const zoom =
              e.chart.sessionVariables.axisX[0].newViewportMaximum -
              e.chart.sessionVariables.axisX[0].newViewportMinimum;
            const interval = zoom ? vm.timeDiff(zoom, width) : vm.timeDiff(timestamp, width);
            e.chart.axisX[0].interval = interval;
            return moment(e.value).locale(vm.locale).format('DD MMM HH:mm');
          },
        },
        axisY: {
          minimum: 0,
          maximum: 120,
          lineThickness: 0,
          tickThickness: 0,
          gridColor: '#000000',
          labelFontColor: 'grey',
          interval: 20,
          includeZero: false,
          stripLines: [
            {
              value: vm.targetEfficiency,
              //label: 'Цель',
              color: '#008736',
            },
          ],
          // margin: 10,
        },
        toolTip: {
          contentFormatter: function (e) {
            const value = e.entries[0].dataPoint.y;
            const color = e.entries[0].dataSeries.color;
            const start = moment(e.entries[0].dataPoint.x).locale(vm.locale).format('DD MMM HH:mm');
            return `${start}: <b><font color=${color}>${value}%</font></b>`;
          },
        },
        data: vm.dataSeries,
      };
    },
    minDate() {
      return this.period.dateStart
        ? new Date(this.period.dateStart).getTime()
        : new Date().getTime();
    },
    maxDate() {
      return this.period.dateEnd ? new Date(this.period.dateEnd).getTime() : new Date().getTime();
    },
    loading() {
      return this.$apollo.queries.efficiencyValues.loading;
    },
  },
  updated() {
    this.updateChart();
  },
  methods: {
    updateChart() {
      const chartId = 'efficiencyChartContainer';
      if (document.getElementById(chartId)) {
        this.chart = new canvas.Chart(chartId, this.chartOptionsCj);
        this.chart.render();
      }
    },
    timeDiff(timestamp, width) {
      const thirtyMinutes = 1800000;
      const fifteenMinutes = 900000;
      const day = 86400000;
      const days = timestamp / day;
      const daysRounded = Math.round(days);
      const intervalZoom =
        days < 0.2 ? this.isMobile(width, fifteenMinutes) : this.isMobile(width, thirtyMinutes);
      const interval =
        days < 0.5 ? intervalZoom : (daysRounded * day) / this.dayCount(daysRounded, width);
      return interval;
    },
    isMobile(width, time) {
      return width > 1281 ? time : width > 500 ? time * 2 : time * 4;
    },
    dayCount(days, width) {
      return width > 1281 ? (days <= 1 ? 24 : days > 24 ? days / 2 : days) : width > 500 ? 12 : 8;
    },
    getPointColor(value) {
      {
        return value == 3
          ? '#9b0000'
          : value < this.targetEfficiency * 0.7
          ? '#FF0000'
          : this.targetEfficiency * 0.7 <= value && value < this.targetEfficiency
          ? '#FC9A40'
          : '#008736';
      }
    },
  },
};
</script>
